import React, { useState } from 'react';

interface CounterProps {
  className?: string;
  count: number;
  decDataTestId?: string;
  incDataTestId?: string;
  countDataTestId?: string;
  onCountChange?: (count: number) => void;
}

export const Counter = (props: CounterProps) => {
  const {
    className,
    count = 0,
    onCountChange,
    decDataTestId,
    incDataTestId,
    countDataTestId,
  } = props;

  const increment = () => {
    if (onCountChange) {
      onCountChange(count + 1);
    }
  };

  const decrement = () => {
    if (count > 0 && onCountChange) {
      onCountChange(count - 1);
    }
  };

  return (
    <div
      className={`flex justify-center items-center w-fit h-6 ${className}`}
      style={{
        border: '1px solid #000',
        borderLeft: 'none',
        borderRight: 'none',
      }}
    >
      <button
        data-testid={decDataTestId}
        onClick={decrement}
        className='px-2 border border-black text-black h-6'
      >
        -
      </button>
      <span className='mx-4' data-testid={countDataTestId}>
        {count}
      </span>
      <button
        data-testid={incDataTestId}
        onClick={increment}
        className='px-2 border border-black text-black h-6'
      >
        +
      </button>
    </div>
  );
};
